export default __webpack_public_path__ + "static/media/rarity-btn-epic.55908c2a.svg";